/* eslint-disable react-hooks/exhaustive-deps */
import {
  contractorStatusData,
  countyList,
  projectList,
  stateList,
} from "../utils/constants";
import BasicSelect from "./common/basicSelect";
import { FormEvent, Fragment, useEffect, useState } from "react";

const FindContractor = () => {
  const [selectedState, setSelectedState] = useState<any>("none");
  const [selectedCounty, setSelectedCounty] = useState<any>("none");
  const [contractorName, setContractorName] = useState("");
  const [loading, setLoading] = useState<boolean>(false);
  const [showData, setShowData] = useState<any>([]);
  const [enableLoadMore, setEnableLoadMore] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [firstLoaded, setfirstLoaded] = useState(false);
  const [contractorStatus, setcontractorStatus] = useState<
    "Approved" | "Suspended" | "Terminated" | "none"
  >("Approved");
  const [selectedProject, setselectedProject] = useState("none");
  const [searchDate, setsearchDate] = useState<any>(null);

  const onReset = () => {
    setfirstLoaded((prev) => (prev = false));
    setSelectedState((prev: any) => (prev = "none"));
    setSelectedCounty((prev: any) => (prev = "none"));
    setcontractorStatus((prev) => (prev = "Approved"));
    setContractorName((prev) => (prev = ""));
    setShowData((prev: any) => (prev = []));
    setEnableLoadMore((prev) => (prev = false));
    setCurrentPage((prev) => (prev = 0));
    setselectedProject((prev) => (prev = "none"));
    setsearchDate((prev: any) => (prev = null));
  };

  const searchData = (e: FormEvent) => {
    e.preventDefault();
    fetchData(true);
  };

  const loadMore = () => {
    setCurrentPage(currentPage + 1);
  };

  const fetchData = (newSearch: boolean) => {
    setLoading(true);
    if (contractorName.length) {
      setSelectedState(() => "none");
      setSelectedCounty(() => "none");
      setselectedProject(() => "none");
      setfirstLoaded(() => false);
      setCurrentPage(() => 0);
      setShowData((prev: any) => (prev = []));
    }
    const apiUrl = `${
      process.env.REACT_APP_API_BASE_URL
    }/contractors/search?name=${encodeURIComponent(
      contractorName ?? ""
    )}&currentPage=${currentPage}&pageSize=12&region=${encodeURIComponent(
      selectedState === "none" ? "" : selectedState
    )}&county=${encodeURIComponent(
      selectedCounty === "none" ? "" : selectedCounty
    )}&status=${
      contractorName ? "" : contractorStatus
    }&project=${encodeURIComponent(
      selectedProject === "none" ? "" : selectedProject
    )}`;

    fetch(apiUrl, {
      method: "GET",
    })
      .then((response) => {
        response.json().then((data: any) => {
          if (data?.length) {
            setShowData(newSearch ? data : [...showData, ...data]);
            data[0].totalitems > 12 && data.length === 12
              ? setEnableLoadMore(true)
              : setEnableLoadMore(false);
          } else {
            newSearch && setShowData([]);
            setEnableLoadMore(false);
          }
          setLoading(false);
          setsearchDate(new Date().toLocaleDateString());
          setfirstLoaded(true);
        });
      })
      .catch((error) => {
        console.log("error", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (firstLoaded) {
      fetchData(false);
    }
  }, [currentPage]);

  const handleChangeCounty = (value: string) => {
    setContractorName(() => "");
    setSelectedCounty(() => value);
    if (value !== "none") {
      setSelectedState(() => value.split(",")[1].trim());
      return;
    }
    setSelectedState(() => "none");
  };

  const handleChangeState = (value: string) => {
    setContractorName(() => "");
    setSelectedState(() => value);
    setSelectedCounty(() => "none");
  };

  return (
    <div className="contractor-body">
      <form onSubmit={searchData}>
        <div className="contractor-top-section">
          <BasicSelect
            id="contractor-select-three"
            labelValue="Contractor Status"
            values={contractorStatusData[selectedState]}
            value={contractorStatus}
            handleOnChange={setcontractorStatus}
          />
          <BasicSelect
            id="contractor-select-one"
            labelValue="Select State"
            values={
              stateList[contractorStatus][
                selectedCounty !== "none"
                  ? selectedCounty.split(",")[1].trim()
                  : "none"
              ]
            }
            value={selectedState}
            handleOnChange={handleChangeState}
          />
          <BasicSelect
            id="contractor-select-two"
            labelValue="Select County"
            values={countyList[selectedState]}
            value={selectedCounty}
            wholeValue
            handleOnChange={handleChangeCounty}
          />
          <BasicSelect
            id="contractor-select-four"
            labelValue="Select Project"
            values={projectList[selectedState]}
            value={selectedProject}
            handleOnChange={setselectedProject}
          />
          <div className="or">Or</div>
          <input
            id="contractor-name-input"
            placeholder="Search By Contractor Name"
            value={contractorName}
            onChange={(e) => {
              setContractorName(() => e.target.value);
            }}
          />
        </div>
        <div className="button-space">
          <button
            disabled={loading}
            id="search"
            className="renew-primary-button"
            type="submit"
          >
            <span>Search</span>
          </button>
          <button
            id="reset"
            className="renew-primary-button"
            type="button"
            disabled={loading}
            onClick={onReset}
          >
            <span>Reset</span>
          </button>
        </div>
      </form>
      {/* <div> {showData?.length} </div> */}
      <div className="contractor-box-section">
        {searchDate ? (
          <div>
            <div style={{ fontSize: "1.6rem", color: "#53565a" }}>
              Search Results as of {searchDate}
            </div>
          </div>
        ) : null}
        {showData?.length === 0 && !loading ? (
          <div className="contractor-box-text">
            Select your state or contractor to start searching
          </div>
        ) : null}
        <div className="contractor-box-container">
          {loading ? (
            <div
              className="overlay"
              style={{ backgroundPosition: "50% -14px" }}
            ></div>
          ) : null}
          {showData?.length > 0 ? (
            <Fragment>
              {showData?.map((item: any) => (
                <div key={item.id} className="contractor-box">
                  <div className="contractor-box-inner">
                    <div className="contractor-box-inner-left">
                      <a
                        className="contractor-box-link"
                        // target="_"
                        href={
                          `/contractor/${encodeURIComponent(
                            item.salesforce_id // slugify(item.name.replaceAll("&", "n"), {
                            //   strict: true,
                            //   lower: true,
                            //   replacement: "-",
                            // })
                          )}`
                          // + `-${encodeURIComponent(item.id.toString())}`
                        }
                        style={{
                          fontWeight: "bold",
                          fontSize: "1.5rem",
                        }}
                      >
                        {item?.name}
                      </a>
                      <div
                        className="contractor-box-body"
                        style={{
                          fontSize: "1rem",
                          marginTop: "0.6rem",
                          marginBottom: "0.6rem",
                        }}
                      >
                        {item?.street_address} <br />
                        {item?.locality}, {item.region} {item.postal_code}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          fontSize: "0.9rem",
                        }}
                      >
                        <div>
                          <strong>Status: </strong>
                          {item.status}
                        </div>
                        <a
                          className="contractor-box-link"
                          href={`/contractor/${encodeURIComponent(
                            item.salesforce_id
                            // slugify(item.name.replaceAll("&", "n"), {
                            //   strict: true,
                            //   lower: true,
                            //   replacement: "-",
                            // })
                          )}`}
                          style={{ fontWeight: "bold" }}
                        >
                          Learn More
                        </a>
                      </div>
                    </div>
                    {item.imageUrl ? (
                      <div className="contractor-box-inner-right">
                        <img
                          className="contractor-box-logo"
                          src={item.imageUrl ?? ""}
                          alt={"logo" + item.id}
                        />
                      </div>
                    ) : null}
                  </div>
                </div>
              ))}
            </Fragment>
          ) : null}
        </div>
        {enableLoadMore ? (
          <button className="load-more-button" onClick={loadMore}>
            <span>Load more</span>
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default FindContractor;
